let Bokeh = require('./bokeh');
let Lazyload = require('./lazyload');
let Recaptcha = require('./recaptcha');
let Datepicker = require('./datepicker');

const Components = {
  Bokeh,
  Lazyload,
  Recaptcha,
  Datepicker
};

module.exports = Components;
